import React, { FC, useState } from "react";
import { Button, Empty, Spin, Tooltip, Typography } from "antd";
import moment from "moment";
import { cloneDeep, get, find } from "lodash";

// import TextEditor from "@components/textEditor";
import "./tableActions.scss";
import membersService from "@services/members.service";
import CareCoordinationService from "@services/care-coordination";
// import { members } from "@pages/?member-details/profile/constants";
import Icon from "@assets/icon_config";
import { formatDisplayDate, getNoteMaxLength } from "@utils/helpers";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import { CARE_MANAGEMENT_SCREEN_TITLE, CASE_STATUS_REASON_NOTE, USER_ACTION_CARD_PROGRAM, USER_ACTION_DESCRIPTION_NOTE_BOOKMARK, USER_ACTION_DESCRIPTION_NOTE_DELETE, USER_ACTION_DESCRIPTION_NOTE_SAVE, USER_ACTION_DESCRIPTION_NOTE_UPDATE, USER_ACTION_LOCATION_GOAL_NOTE, USER_ACTION_LOCATION_TASK_NOTE, USER_ACTION_MODULE_MEMBER_DETAIL, USER_ACTION_TAB_CARE_MANAGEMENT } from "@utils/constants";
import TextAreaComp from "@components/textArea";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";
import RichTextEditorComp from "@components/richTextEditor/richText";
import { useRTEState } from "@components/richTextEditor/useRTEState";
import useSession from "@utils/useSession";
import RichTextEditor from "@components/richTextEditor";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";

type TNotesProps = {
  data?: any;
  editHandler?: any;
  deleteHandler?: any;
  bookmarkHandler?: any;
  addNoteHanlder?: any;
  patientId?: number;
  patientStatus?: string;
  closePopOver?: any;
  noteType?: any;
  screen?: string;
  page?: any;
  disabled?: boolean;
  taskDescription?:string;
  taskId?: any;
  interventionId?: any;
};

const viewType = ["listing", "addNote"];
const { Text } = Typography;

const NotesAction: FC<TNotesProps> = ({
  data,
  deleteHandler,
  bookmarkHandler,
  addNoteHanlder,
  editHandler,
  patientId,
  patientStatus,
  closePopOver,
  screen,
  page,
  noteType,
  disabled,
  taskDescription,
  taskId,
  interventionId,
}: TNotesProps) => {
  const notesWordLimit = getNoteMaxLength();
  const { bookmarkStatus, setBookmarkStatus, recipientType, setRecipientType, prevBookmarkStatus, setPrevBookmarkStatus, recipientValue } = useRTEState();

  const [type, setViewType] = useState(viewType[0]);
  const [noteContent, noteContentHandler] = useState(``);
  const [currentNote, setCurrentNote] = useState({ notesId: -1, notes: "" });
  const [addLoader, setAddLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [bookmarkLoader, setBookmarkLoader] = useState(false);
  const [itemToDelete, setItemToDelete] = useState();
  const [itemToBookmark, setItemToBookmark] = useState();
  const [editFlag, setEditFlag] = useState(false);
  const session = useSession();

  const shouldShowCustomControls = true;
  const programsData = cloneDeep(useCareCoordinationStore((state) => state.dataForCareCoordination));
  const activeIntervention = find(programsData?.interventions, { id: interventionId });
  const activeTask = find(activeIntervention?.tasks, { id: taskId });
  const currentMember =  membersService?.getCurrentMember;
  const getUserActionParams = (userActionDescription: any, userActionLocation: any) => {
    let props = {
      caseStatusReasonTxt: CASE_STATUS_REASON_NOTE,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CARE_MANAGEMENT,
      actionCard: `${get(programsData , 'displayName')}$|${get(programsData, "patientProgramId")}$|${USER_ACTION_CARD_PROGRAM}`,
      actionLocation: userActionLocation,
      actionDescription: userActionDescription,
    };
    return props;
  };

  const viewTypeChangeHandler = (type: string) => {
    setViewType(type);
    setEditFlag(false);
    noteContentHandler("");
    setCurrentNote({ notesId: -1, notes: "" });
    setBookmarkStatus({isBookmarked: false})
    setRecipientType(false)
    setPrevBookmarkStatus({isBookmarked: false})
  };

  const editNotesHandler = (item: any) => {
    setEditFlag(true);
    setViewType(viewType[1]);
    item.notesCreateDate = moment.utc();
    noteContentHandler(item.notes);
    setBookmarkStatus({isBookmarked: item.isBookMarked})
    setPrevBookmarkStatus({ isBookmarked: item.isBookMarked})
    setRecipientType(item.recipientType === "PCP" ? true : false)
    setCurrentNote(item);

  };
  const listingView = () => {
    return (
      <>
        {/*<div onClick={() => closePopOver()} className="close-popover">	
          <Icon name={'close'} />	
    </div>*/}
        <div className="note-header-wrapper flex v-center">
          <h1 className="notes-popup-title">Notes ({data?.length})</h1>
          <div className="ml-auto d-flex d-flex--center">
            <CanEdit>
              <Button className="ml-auto" onClick={() => viewTypeChangeHandler(viewType[1])} title="Add" type="text" disabled={disabled}>
                <Icon name="add" height="24" width="24" />
              </Button>
            </CanEdit>
            <div onClick={() => closePopOver()} className="close-popover">
              <Icon name={"close"} />
            </div>
          </div>
        </div>
        <div className="notes-list-container custom-scroll-bar">
          {!data?.length && <DataNotFound message={NO_DATA_FOUND}/>}

          {data?.map((item: any) => { 
            const isLoggedInUser = item.careMgrId === session?.user?.id;
            const allowedTags = ['strong', 'u', 'em', 'a'];
            const sanitizedContent = item.notes
              .replace(/<[^>]+>/g, (t: any) => {
                const tag = t.match(/<\/?(\w+)/);
                if (tag && allowedTags.includes(tag[1])) {
                  return t;
                } else {
                  return ''; 
                }
              })
            // Tooltip ellipsis
            const plainTextLength = sanitizedContent.replace(/<[^>]*>/g, "").length;
            const tooltipTitle = plainTextLength > 100 ? `${sanitizedContent.substring(0, 80)}...` : sanitizedContent;
 
            return (
              <div className="note-content-wrapper" key={item.notesId}>
                <div className="flex">
                  <Tooltip title={<div dangerouslySetInnerHTML={{ __html: tooltipTitle }} />} className="note-content-tooltip">
                    <span className="note-content">
                      <Text style={item?.notes?.length > 0 ? { width: 215 } : undefined} ellipsis={item?.notes?.length > 0 ? true : false}>
                        <div className="note-content ant-typography ant-typography-ellipsis" style={{ width: 215, maxWidth: '100%', overflow: 'hidden', margin: 0 }} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
                      </Text>
                    </span>
                  </Tooltip>
                  <div className="note-content-wrapper__note-edit-fields">
                    {item.isBookMarked ? (
                      <Spin spinning={bookmarkLoader && item.notesId === itemToBookmark} indicator={<HealthemSpinner />}>
                        <div className="icon icon-bookmark-solid clr-themeColor f20 pointer" onClick={() => bookmarkNotes(item)} />
                      </Spin>
                    ) : (
                      <Spin spinning={bookmarkLoader && item.notesId === itemToBookmark} indicator={<HealthemSpinner />}>
                        <div className="icon icon-bookmark f20 pointer" style={{ color: "#f2960d" }} onClick={() => bookmarkNotes(item)} />
                      </Spin>
                    )}
                    {isLoggedInUser && (
                      <CanEdit>
                        <div className="note-content-wrapper__note-edit-fields__editDelete">
                          <div>
                            <div
                              className={`icon-edit f18  ${disabled ? "disabledGoal" : "clr-blueLink pointer"}`}
                              onClick={() => {
                                if (disabled) {
                                  return false;
                                }
                                editNotesHandler(item);
                              }}
                            />
                          </div>
                          <div>
                            <Spin spinning={deleteLoader && item.notesId === itemToDelete} indicator={<HealthemSpinner />}>
                              <div
                                className={`icon-delete f18  ${disabled ? "disabledGoal" : "clr-e100 pointer"}`}
                                onClick={() => {
                                  if (disabled) {
                                    return false;
                                  }
                                  deleteNotes(item);
                                }}
                              />
                            </Spin>
                          </div>
                        </div>
                      </CanEdit>
                    )}
                  </div>
                </div>
                <div className="flex v-center">
                  <span className="note-time">
                    {formatDisplayDate(item.notesCreateDate, "reminderDateActualFormat", "defaultDateFormatWithTimeWithPipe", true)} | {item.careMgrFirstName} {item.careMgrLastName}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const customControlData = shouldShowCustomControls
    ? {
        showCustomControls: true,
        bookmarkStatus: bookmarkStatus,
        setBookmarkStatus: setBookmarkStatus,
        recipientType: recipientType,
        setRecipientType: setRecipientType
      }
    : {
        showCustomControls: false,
      };
      const noteContentLength = noteContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length;  
  const newNoteView = () => {
    return (
      <div className="new-note-container">
        <div className="note-header-wrapper flex v-center">
          <h1 className="f16 w500" style={{ color: "#112a49" }}>
            {editFlag ? "Update" : "Add"} Note
          </h1>
        </div>
        <div className="note-body">
          {/* <TextAreaComp content={noteContent} changeHandler={editorChangeHandler} actionsMenu={false} autoFocus={true} showCount={true} wordLimit={notesWordLimit} /> */}
          <RichTextEditor editMode={editFlag} content={noteContent} changeHandler={noteContentHandler} customControlData={customControlData} actionsMenu={false} autoFocus={false} showCount={true} wordLimit={getNoteMaxLength()} />

        </div>
        <div className="addd-note-footer">
          <Button type="default" size="large" className="cancel-button" onClick={() => viewTypeChangeHandler(viewType[0])}>
            Cancel
          </Button>
          <Spin spinning={addLoader} indicator={<HealthemSpinner />}>
            <Button type="primary" size="large" className="add-notes" onClick={addNewNote} disabled={ !noteContentLength || noteContentLength > notesWordLimit}>
              {editFlag ? "Update" : "Add"}
            </Button>
          </Spin>
        </div>
      </div>
    );
  };

  const addNewNote = () => {
    setAddLoader(true);
    let noteId = cloneDeep(currentNote.notesId);
    let noteBody = cloneDeep(noteContent);
    if (noteId > -1) {
      switch (screen) {
        case CARE_MANAGEMENT_SCREEN_TITLE:
          let localNote = {
            patientId: patientId,
            description: noteBody,
            noteId: noteId,
            isBookmarked: bookmarkStatus.isBookmarked,
            recipientType: recipientValue,
            prevBookmarkStatus: prevBookmarkStatus.isBookmarked
          };
          CareCoordinationService.editNote(localNote).subscribe({
            next: (res) => {
              let updatedNote = res?.data?.data?.note;
              editHandler(updatedNote, noteId);
              setAddLoader(false);
              setViewType(viewType[0]);
              noteContentHandler("");
              setCurrentNote({ notesId: -1, notes: "" });
            },
            error: (v) => {
              console.log(v);
              setAddLoader(false);
            },
          });
          if(page === "goal-note") {
          const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
            USER_ACTION_DESCRIPTION_NOTE_UPDATE,
            USER_ACTION_LOCATION_GOAL_NOTE
          );
          membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
            next: (v) => {
              console.log("updated status successfully")
            },
            error: (e) => {
              console.log("update status failed")
            },
          });
        }
        else {
          const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
            USER_ACTION_DESCRIPTION_NOTE_UPDATE,
            `${get(activeTask, 'description')}$|${USER_ACTION_LOCATION_TASK_NOTE}`
          );
          membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
            next: (v) => {
              console.log("updated status successfully")
            },
            error: (e) => {
              console.log("update status failed")
            },
          });
        }
          break;
        default:
          membersService.editNotes(noteId, patientId, noteBody, bookmarkStatus.isBookmarked, recipientValue, prevBookmarkStatus.isBookmarked).subscribe({
            next: (res) => {
              let updatedNote = res?.data?.data?.note;
              setAddLoader(false);
              editHandler(updatedNote, noteId);
              setViewType(viewType[0]);
              noteContentHandler("");
              setCurrentNote({ notesId: -1, notes: "" });
            },
            error: () => {
              setAddLoader(false);
            },
          });
      }
    } else {
      switch (screen) {       
        case CARE_MANAGEMENT_SCREEN_TITLE:
          let localNote = {
            patientId: patientId,
            description: noteBody,
            ...noteType, 
            isBookmarked: bookmarkStatus.isBookmarked,
            recipientType: recipientValue,
          };
          CareCoordinationService.createNote(localNote).subscribe({
            next: (res) => {
              const noteData = {
                  isBookmarked: bookmarkStatus.isBookmarked,
                  data: res?.data?.data?.note,
              }
              addNoteHanlder(noteData);
              setAddLoader(false);
              setViewType(viewType[0]);
              noteContentHandler("");
              setCurrentNote({ notesId: -1, notes: "" });
            },
            error: (v) => {
              console.log(v);
            },
          });
          if(page === "goal-note") {
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
              USER_ACTION_DESCRIPTION_NOTE_SAVE,
              USER_ACTION_LOCATION_GOAL_NOTE
            );
            membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
              next: (v) => {
                console.log("updated status successfully")
              },
              error: (e) => {
                console.log("update status failed")
              },
            });
          }
          else {
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
              USER_ACTION_DESCRIPTION_NOTE_SAVE,
              `${get(activeTask, 'description')}$|${USER_ACTION_LOCATION_TASK_NOTE}`
            );
            membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
              next: (v) => {
                console.log("updated status successfully")
              },
              error: (e) => {
                console.log("update status failed")
              },
            });
          }
          break;
        default:
          membersService.addNotes([patientId], noteBody, noteType, bookmarkStatus.isBookmarked, recipientValue).subscribe({
            next: (res) => {
              setAddLoader(false);
              const noteData = {
                data: res?.data?.data?.note[0],
                isBookmarked: bookmarkStatus.isBookmarked,
              }
              
              addNoteHanlder(noteData);
              setViewType(viewType[0]);
              noteContentHandler("");
              setCurrentNote({ notesId: -1, notes: "" });
            },
            error: () => {
              setAddLoader(false);
            },
          });
      }
    }
  };

  const deleteNotes = (item: any) => {
    setDeleteLoader(true);
    setItemToDelete(item.notesId);
    switch (screen) {
      case CARE_MANAGEMENT_SCREEN_TITLE:
        let localNote = {
          noteId: item.notesId,
          patientId: patientId,
          ...noteType,
        };
        CareCoordinationService.removeNote(localNote).subscribe({
          next: (res) => {
            deleteHandler(item.notesId);
            setDeleteLoader(false);
          },
          error: (v) => {
            console.log(v);
            setDeleteLoader(false);
          },
        });
        if(page === "goal-note") {
          const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
            USER_ACTION_DESCRIPTION_NOTE_DELETE,
            USER_ACTION_LOCATION_GOAL_NOTE
          );
          membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
            next: (v) => {
              console.log("updated status successfully")
            },
            error: (e) => {
              console.log("update status failed")
            },
          });
        }
        else {
          const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
            USER_ACTION_DESCRIPTION_NOTE_DELETE,
            `${get(activeTask, 'description')}$|${USER_ACTION_LOCATION_TASK_NOTE}`
          );
          membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
            next: (v) => {
              console.log("updated status successfully")
            },
            error: (e) => {
              console.log("update status failed")
            },
          });
        }
        break;
      default:
        membersService.deleteNotes(item.notesId).subscribe({
          next: () => {
            setDeleteLoader(false);
            deleteHandler(item.notesId);
          },
          error: () => {
            setDeleteLoader(false);
          },
        });
    }
  };

  const bookmarkNotes = (item: any) => {
    setBookmarkLoader(true);
    setItemToBookmark(item.notesId);
    membersService.bookmarkNotes(item.notesId, !item.isBookMarked).subscribe({
      next: () => {
        setBookmarkLoader(false);
        bookmarkHandler(item.notesId);
      },
      error: () => {
        setBookmarkLoader(false);
      },
    });
    if(page === "goal-note") {
      const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
        USER_ACTION_DESCRIPTION_NOTE_BOOKMARK,
        USER_ACTION_LOCATION_GOAL_NOTE
      );
      membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (v) => {
          console.log("updated status successfully")
        },
        error: (e) => {
          console.log("update status failed")
        },
      });
    }
    else {
      const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
        USER_ACTION_DESCRIPTION_NOTE_BOOKMARK,
        `${get(activeTask, 'description')}$|${USER_ACTION_LOCATION_TASK_NOTE}`
      );
      membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (v) => {
          console.log("updated status successfully")
        },
        error: (e) => {
          console.log("update status failed")
        },
      });
    }
  };

  const editorChangeHandler = (data: any) => {
    console.log("editor change handler data", data);
    noteContentHandler(data);
  };

  return (
    <div className="notes-action-wrapper">
      {type === viewType[0] ? listingView() : null}

      {type === viewType[1] ? newNoteView() : null}
    </div>
  );
};
export default NotesAction;
